// extracted by mini-css-extract-plugin
module.exports = {"statusTextHolder":"PresenterMicStatusText_statusTextHolder__2qrdB","statusTextHolderBackstage":"PresenterMicStatusText_statusTextHolderBackstage__2pfF7"};